module.exports = __webpack_public_path__ + "img/profile2.347dc413.webp";